<div [ngClass]="env && env !== 'PROD' ? 'component' : ''">
	<div class="app">
		<div class="hallmark"></div>
		<div class="title-section">
			<h2 class="main-title">NDA Assist Dashboard</h2>
			<p class="subtitle">CHEVRON LEGAL INTELLIGENCE PLATFORM<span *ngIf="env && env !== 'PROD'" class="env-badge">[{{ env }}]</span></p>
		</div>
	</div>
	<div *ngIf="appSettings.user" class="user">
		<div class="welcome">
			<div class="welcome-text">Welcome</div>
			<div class="user-name-section" (click)="toggleWorkspaceSwitcher()" title="Click to switch workspace">
				<span>{{ appSettings.user.name }}</span>
				<span class="dropdown-arrow" [ngClass]="{ 'open': showWorkspaceSwitcher }">▼</span>
			</div>
		</div>
		<div class="profile" (click)="toggleWorkspaceSwitcher()" title="Switch Workspace">
			<img *ngIf="showPhoto" [src]="appSettings.user.photo" (error)="showPhoto = false" height="100%" [alt]="appSettings.user.name">
			<div *ngIf="!showPhoto" class="initials">{{ appSettings.user.initials }}</div>
		</div>
	</div>

</div>

<!-- Workspace Switcher Backdrop -->
<div *ngIf="showWorkspaceSwitcher" class="workspace-switcher-backdrop" #wsBackdrop (click)="closeWorkspaceSwitcher()"></div>

<!-- Workspace Switcher Component -->
<div *ngIf="showWorkspaceSwitcher" #workspaceSwitcherModal class="workspace-switcher-modal">
	<app-workspace-switcher (closeWorkspaceSwitcher)="closeWorkspaceSwitcher()"></app-workspace-switcher>
</div>
